/**
 * AI Agent Node Defaults (v2.0 - Sub-Node Architecture)
 */
export const defaults = {
  systemPrompt: 'You are a helpful AI assistant.',
  userPrompt: '{{ $json.chatInput || $json.input || $json.message }}',
  responseStyle: 'concise',
  requiresAction: false,
  binaryHandling: 'auto',
  binaryFieldName: '',
  maxIterations: 10,
  returnIntermediateSteps: false,
  outputKey: 'output'
};
